/**
 * Dati strutturati schema.org. Non cambiano niente di visibile: servono a
 * dire ai motori di ricerca che queste pagine sono strutture ricettive con
 * camere e prezzi, e non pagine qualsiasi.
 */

const SITO = "https://www.newmoonrooms.it";
const TELEFONO = "+393348956214";
const EMAIL = "info@newmoonrooms.it";

const SEDI = {
  cavour: {
    nome: "New Moon Cavour",
    via: "Corso Cavour, 160",
    cap: "19121",
    lat: 44.106733,
    lng: 9.816082,
  },
  prione: {
    nome: "New Moon Del Prione",
    via: "Via del Prione, 165",
    cap: "19121",
    lat: 44.1045506,
    lng: 9.8198126,
  },
};

function sedeLd(id) {
  const sede = SEDI[id];
  return {
    "@type": "LodgingBusiness",
    "@id": `${SITO}/structures/${id}`,
    name: sede.nome,
    url: `${SITO}/structures/${id}`,
    telephone: TELEFONO,
    email: EMAIL,
    address: {
      "@type": "PostalAddress",
      streetAddress: sede.via,
      addressLocality: "La Spezia",
      postalCode: sede.cap,
      addressRegion: "SP",
      addressCountry: "IT",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: sede.lat,
      longitude: sede.lng,
    },
    checkinTime: "15:00",
    checkoutTime: "10:00",
    currenciesAccepted: "EUR",
    petsAllowed: false,
  };
}

/** Home: entrambe le strutture. */
export function ldStrutture() {
  return {
    "@context": "https://schema.org",
    "@graph": [sedeLd("cavour"), sedeLd("prione")],
  };
}

/** Pagina struttura: la sede piu' l'elenco delle sue camere. */
export function ldStruttura(id, camere, traduci, immagine) {
  return {
    "@context": "https://schema.org",
    ...sedeLd(id),
    ...(immagine ? { image: `${SITO}${immagine}` } : {}),
    containsPlace: camere.map((room) => ({
      "@type": "HotelRoom",
      name: traduci(room.nameKey),
      url: `${SITO}/structures/${id}/${room.id}`,
      occupancy: { "@type": "QuantitativeValue", maxValue: room.guests },
    })),
  };
}

/** Pagina camera: la camera, e il prezzo solo se lo conosciamo davvero. */
export function ldCamera({
  strutturaId,
  room,
  nome,
  descrizione,
  prezzo,
  immagini,
}) {
  const camera = {
    "@context": "https://schema.org",
    "@type": "HotelRoom",
    name: nome,
    url: `${SITO}/structures/${strutturaId}/${room.id}`,
    description: descrizione,
    bed: { "@type": "BedDetails", numberOfBeds: room.beds },
    occupancy: { "@type": "QuantitativeValue", maxValue: room.guests },
    containedInPlace: { "@id": `${SITO}/structures/${strutturaId}` },
  };

  // Massimo sei foto: oltre non serve a Google e appesantisce l'HTML.
  if (immagini && immagini.length) {
    camera.image = immagini.slice(0, 6).map((src) => `${SITO}${src}`);
  }

  const mq = parseInt(room.size, 10);
  if (!Number.isNaN(mq)) {
    camera.floorSize = {
      "@type": "QuantitativeValue",
      value: mq,
      unitCode: "MTK",
    };
  }

  if (prezzo) {
    camera.offers = {
      "@type": "Offer",
      price: Math.round(prezzo),
      priceCurrency: "EUR",
      availability: "https://schema.org/InStock",
      url: `${SITO}/structures/${strutturaId}/${room.id}`,
    };
  }

  return camera;
}
